import { render, staticRenderFns } from "./ProductDetailDialog.vue?vue&type=template&id=1407dc56&scoped=true"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407dc56",
  null
  
)

export default component.exports